module.exports = __webpack_public_path__ + "img/maintop.bc57961.png";